// Copyright (c) 2022 Enabler Interactive Pty Ltd

import React, { Component } from 'react'
import { Link } from 'react-router'
import { Col, Clearfix, Table, Button, Row, Modal, FormGroup, FormControl, Form, Checkbox, Panel } from 'react-bootstrap'
import { BsSortUp, BsSortDown } from 'react-icons/bs'
import { Message } from '../components/message'
import { Loading } from '../components/loading'
import config from '../config/config.json'
import { evalDateHour, evalRatingClass, fixScrollbar } from '../utils/enUtils.js'

export class WorkforceSummary extends Component {
    constructor(props) {
        super(props)

        this.getWorkersByProvider(this.props.env, config)
        this.getAvailableCategories(this.props.env, config)

        this.state = {
            deleteWorker: false,
            showDeleteWorkerModal: false,
            workerToDeleteId: '',
            workerToDeleteName: '',
            workerToDeleteIndex: -1,
            displaySaveCategory: 'none',
            availableCategories: [],
            selectedcategories: [],
            addCategoryButtonContainersDisplay: 'block',
            saveCategoryButtonContainersDisplay: 'none',
            workerCategoriesSectionDisplay: 'block',
            availableCategoriesSectionDisplay: 'none',
            categoryFilter: 'All',
            ratingFilter: 'All',
            searchString: '',
            filteredWorkers: this.props.workers,
            sortColumn: 'worker',
            sortOrder: 'asc',
            currentDate: evalDateHour(Date.now()),
            editingCategory: false,
            loading: true
        }

        this.handleOnClick = this.handleOnClick.bind(this)
        this.openDeleteWorkerModal = this.openDeleteWorkerModal.bind(this)
        this.handleDeleteWorker = this.handleDeleteWorker.bind(this)
        this.closeDeleteWorkerModal = this.closeDeleteWorkerModal.bind(this)
        this.confirmDeleteWorker = this.confirmDeleteWorker.bind(this)
        this.deleteWorkerApi = this.deleteWorkerApi.bind(this)
        //this.filterStatus = this.filterStatus.bind(this)
        this.filterCategory = this.filterCategory.bind(this)
        this.filterRating = this.filterRating.bind(this)
        this.prepareDeleteWorkerModal = this.prepareDeleteWorkerModal.bind(this)
        this.handleAddCategory = this.handleAddCategory.bind(this)
        this.handleSaveCategory = this.handleSaveCategory.bind(this)
        this.loadAvailableCategories = this.loadAvailableCategories.bind(this)
        this.getAvailableCategories = this.getAvailableCategories.bind(this)
        this.categorySelected = this.categorySelected.bind(this)
        this.handleWorkerClick = this.handleWorkerClick.bind(this)
        this.sortColumn = this.sortColumn.bind(this)
        this.sortIcon = this.sortIcon.bind(this)
        this.searchWorker = this.searchWorker.bind(this)
        this.printReport = this.printReport.bind(this)
        this.downloadCSV = this.downloadCSV.bind(this)
    }

    getWorkersByProvider(env, config) {
        fetch(config[env] + config.api.list_workers.endpoint, {
            method: config.api.list_workers.type,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': this.props.appData.authToken || window.sessionStorage.authToken
            }
        }).then((response) => response.json())
            .then((responseJson) => {
                this.props.handleLoadWorkers(responseJson.workers)
                this.setState({
                    loading: false
                })
            })
            .catch((error) => {
                console.error(error)
            })
    }

    handleOnClick(e) {
        this.props.router.push('/addIndividual')
    }

    handleOnClickApplyLicense(e) {
        e.preventDefault()
        console.log("Apply License ", e)
    }

    handleDeleteWorker(e) {
        e.preventDefault()

        this.setState({
            workerToDeleteId: e.target.getAttribute('data-id'),
            workerToDeleteName: e.target.getAttribute('data-name'),
            workerToDeleteIndex: e.target.getAttribute('data-index')
        })

        this.openDeleteWorkerModal()
    }

    openDeleteWorkerModal() {
        this.setState({
            showDeleteWorkerModal: true
        })
    }

    closeDeleteWorkerModal() {
        this.setState({
            showDeleteWorkerModal: false,
            deleteWorker: false,
            workerToDeleteId: '',
            workerToDeleteName: ''
        })

        fixScrollbar()
    }

    confirmDeleteWorker() {
        this.deleteWorkerApi(this.state.workerToDeleteId, this.props.env, config)

        this.setState({
            showDeleteWorkerModal: false,
            deleteWorker: true
        })

        fixScrollbar()
    }

    deleteWorkerApi(workerId, env, config) {
        fetch(config[env] + config.api.disconnect_worker.endpoint + workerId, {
            method: config.api.disconnect_worker.type,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': this.props.appData.authToken || window.sessionStorage.authToken
            }
        }).then((response) => response.json())
            .then((responseJson) => {
                this.getWorkersByProvider(env, config)
            })
            .catch((error) => {
                console.error(error)
            })
    }

    handleAddCategory(e) {
        e.preventDefault()

        /*document.getElementsByClassName("addCategoryButtonContainer").forEach(element=>{
            element.style.display="block"
        })*/

        let workerCategories = e.target.getAttribute('data-categories').split(',')

        this.setState({
            selectedcategories: workerCategories,
            editingCategory: true
        })

        let allAddCategoryButtonContainers = document.getElementsByClassName("addCategoryButtonContainer")

        for (let i = 0; i < allAddCategoryButtonContainers.length; i++) {
            allAddCategoryButtonContainers[i].style.display = 'block'
        }

        let allSaveCategoryButtonContainers = document.getElementsByClassName("saveCategoryButtonContainer")

        for (let i = 0; i < allSaveCategoryButtonContainers.length; i++) {
            allSaveCategoryButtonContainers[i].style.display = 'none'
        }

        let allWorkerCategoriesDisplayContainers = document.getElementsByClassName("workerCategoriesDisplayContainer")

        for (let i = 0; i < allWorkerCategoriesDisplayContainers.length; i++) {
            allWorkerCategoriesDisplayContainers[i].style.display = 'block'
        }

        let allAddCategoryToWorkerContainers = document.getElementsByClassName("addCategoryToWorker")

        for (let i = 0; i < allAddCategoryToWorkerContainers.length; i++) {
            allAddCategoryToWorkerContainers[i].style.display = 'none'
        }

        let allCategoryOptionsCheckboxes = document.getElementById("addCategoryToWorker_" + e.target.getAttribute("data-index")).getElementsByTagName('input')

        for (let i = 0; i < allCategoryOptionsCheckboxes.length; i++) {

            if (workerCategories.includes(allCategoryOptionsCheckboxes[i].dataset.category))
                allCategoryOptionsCheckboxes[i].checked = true
            else
                allCategoryOptionsCheckboxes[i].checked = false
        }

        document.getElementById("addCategoryToWorker_" + e.target.getAttribute("data-index")).style.display = "block"
        document.getElementById("addCategoryButton_" + e.target.getAttribute("data-index")).style.display = "none"
        document.getElementById("saveCategoryButton_" + e.target.getAttribute("data-index")).style.display = "block"
        document.getElementById("workerCategories_" + e.target.getAttribute("data-index")).style.display = "none"

    }

    handleSaveCategory(e) {
        e.preventDefault()

        document.getElementById("addCategoryToWorker_" + e.target.getAttribute("data-index")).style.display = "block"
        document.getElementById("addCategoryButton_" + e.target.getAttribute("data-index")).style.display = "none"
        document.getElementById("saveCategoryButton_" + e.target.getAttribute("data-index")).style.display = "block"

        let categories = this.state.selectedcategories

        this.addCategoriesToWorker(e.target.getAttribute("data-index"), e.target.getAttribute("data-id"), categories, this.props.env, config)

        this.setState({
            editingCategory: false
        })
    }

    categorySelected(e) {
        if (e.target.checked)
            this.addItemToList(e.target.getAttribute("data-id"), e.target.getAttribute("data-category"))
        else
            this.deleteItemFromList(e.target.getAttribute("data-category"))
    }

    addItemToList(id, name) {
        let selectedcategories = this.state.selectedcategories
        selectedcategories.push(name)
        this.setState({
            selectedcategories
        })
    }

    deleteItemFromList(categoryName) {
        let selectedcategories = this.state.selectedcategories.filter(category => {
            return category !== categoryName
        })
        this.setState({
            selectedcategories
        })
    }

    addCategoriesToWorker(index, workerId, categories = [], env, config) {
        fetch(config[env] + config.api.categorize_workers.endpoint + workerId, {
            method: config.api.categorize_workers.type,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': this.props.appData.authToken || window.sessionStorage.authToken
            },
            body: JSON.stringify({
                'providers_worker': {
                    'categories': categories
                }
            })

        }).then((response) => response.json())
            .then((responseJson) => {
                //this.props.handleLoadWorkers(responseJson.workers)
                this.getWorkersByProvider(env, config)
                document.getElementById("addCategoryToWorker_" + index).style.display = "none"
                document.getElementById("addCategoryButton_" + index).style.display = "block"
                document.getElementById("saveCategoryButton_" + index).style.display = "none"

                this.setState({
                    selectedcategories: []
                })

                document.getElementById("workerCategories_" + index).style.display = "block"
            })
            .catch((error) => {
                console.error(error);
            })
    }

    getAvailableCategories(env, config) {
        fetch(config[env] + config.api.list_categories.endpoint, {
            method: config.api.list_categories.type,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': this.props.appData.authToken || window.sessionStorage.authToken
            }
        }).then((response) => response.json())
            .then((responseJson) => {
                this.setState({
                    availableCategories: responseJson
                })
            })
            .catch((error) => {
                console.error(error)
            })
    }

    loadAvailableCategories(workerCategories = []) {
        return this.state.availableCategories.map((category, index) => {

            let alreadyInWorkerCategory = false

            workerCategories.forEach(workerCategory => {
                if (workerCategory === category.name)
                    alreadyInWorkerCategory = true
            })

            if (alreadyInWorkerCategory)
                return (
                    <Checkbox key={index} defaultChecked data-id={category.id} data-category={category.name} onClick={this.categorySelected} >{category.name}</Checkbox>
                )
            else
                return (
                    <Checkbox key={index} data-id={category.id} data-category={category.name} onClick={this.categorySelected}>{category.name}</Checkbox>
                )
        })
    }

    loadCategoriesDisplay(categories = []) {
        return categories.map((category, index) => {
            if (index !== categories.length - 1) {
                return (
                    <div key={index}>
                        <span>{category}</span>,
                    </div>
                )
            } else {
                return (
                    <div key={index}>
                        <span>{category}</span>
                    </div>
                )
            }
        })
    }

    sortColumn(e) {
        e.preventDefault()
        let columnId = e.target.getAttribute('id')

        if (this.state.sortColumn === columnId) {
            // Already sorted by this column, so invert the order
            let sortOrder = this.state.sortOrder === 'asc' ? 'desc' : 'asc'

            this.setState({
                sortOrder: sortOrder
            })
        } else {
            // Sort by this column, default order to ascending
            this.setState({
                sortColumn: columnId,
                sortOrder: 'asc'
            })
        }
    }

    sortIcon(id) {
        if (this.state.sortColumn === id) {
            if (this.state.sortOrder === 'asc') {
                return (
                    <BsSortUp className="sort-icon" />
                )
            } else {
                return (
                    <BsSortDown className="sort-icon" />
                )
            }
        }
    }

    handleWorkerClick(e) {
        e.preventDefault()

        this.props.handleActiveWorker(e.target.getAttribute('data-id'))
        this.props.router.push('/workforce/summary/content')
    }

    filterStatus(event) {
        let filterVal = event.target.value

        let newWorkers = this.provider.workers.filter((worker) => {
            return (filterVal === "All" ? true : worker.status === filterVal)
        })

        this.setState({
            workers: newWorkers
        })
    }

    filterCategory(e) {
        this.setState({
            categoryFilter: e.target.value
        })
    }

    filterRating(e) {
        this.setState({
            ratingFilter: e.target.value
        })
    }

    loadCategoryFilterOptions() {
        return this.state.availableCategories.map((category, index) => {
            return (
                <option key={index} value={category.name}>{category.name}</option>
            )
        })
    }

    searchWorker(e) {
        this.setState({
            searchString: e.target.value
        })
    }


    get records() {
        if (this.state.loading) {
            return (
                <Loading embedType="tbody" />
            )
        }

        if (this.props.workers.length === 0) {
            return (
                <Message embedType="tbody" text={"No workers in your organisation."} />
            )
        }

        let workersList = this.getFilteredWorkers()

        return workersList.map((worker, index) => {
            let actionMarkup, categoryMarkup = ""

            if (this.state.availableCategories.length === 0) {
                categoryMarkup = (
                    <div id={"addCategoryButton_" + index} className="addCategoryButtonContainer" >
                        <label>
                            <Link to='/manageCategories'>
                                Add Categories
                            </Link>
                        </label>
                    </div>
                )
            }
            else {
                categoryMarkup = (
                    <div>
                        <div id={"addCategoryButton_" + index} className="addCategoryButtonContainer" >
                            <label>
                                <Link to='#' data-index={index} data-id={worker.id} data-categories={worker.categories} onClick={this.handleAddCategory} >
                                    Edit Categories
                                </Link>
                            </label>
                        </div>
                        <div id={"saveCategoryButton_" + index} style={{ display: 'none' }} className="saveCategoryButtonContainer">
                            <label>
                                <Link to="#" data-index={index} data-id={worker.id} onClick={this.handleSaveCategory}>
                                    Save Changes
                                </Link>
                            </label>
                        </div>
                    </div>
                )
            }

            switch (this.evalWorkerStatus(worker)) {
                case "Registered":
                    actionMarkup = (
                        <div>
                            {categoryMarkup}
                            <div>
                                <label>
                                    <Link to='#' data-index={index} data-id={worker.id} data-name={worker.name} onClick={this.handleDeleteWorker}>Disconnect</Link>
                                </label>
                            </div>
                        </div>
                    )
                    break

                default:
                    actionMarkup = (<div></div>)
            }

            return (
                <tr key={index}>
                    <td>
                        <label>
                            <Link onClick={this.handleWorkerClick} data-id={worker.id}>
                                {worker.name}
                            </Link>
                            <span className="workerEmail">{worker.email}</span>
                        </label>
                    </td>
                    <td>
                        <span>{worker.createdAtDate}</span>
                    </td>
                    <td>
                        <span className="lastActiveDate">{worker.lastActiveDate}</span>
                    </td>
                    <td>
                        <span className={evalRatingClass(worker.rating)}>{worker.rating}</span>
                    </td>
                    <td>
                        <Row>
                            <Col sm={12}>
                                <div id={"workerCategories_" + index} className="workerCategoriesDisplayContainer">{this.loadCategoriesDisplay(worker.categories)}</div>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={12}>
                                <Form horizontal className="addCategoryToWorker" id={"addCategoryToWorker_" + index} style={{ display: "none" }} >
                                    <FormGroup>
                                        {this.loadAvailableCategories(worker.categories)}
                                    </FormGroup>
                                </Form>
                            </Col>
                        </Row>
                    </td>
                    <td>
                        {actionMarkup}
                    </td>
                    {this.prepareDeleteWorkerModal()}
                </tr>
            )
        })
    }

    getFilteredWorkers() {
        // Deep copy
        let filteredWorkers = JSON.parse(JSON.stringify(this.props.workers))

        // Apply column filters
        if (this.state.ratingFilter !== "All") {
            filteredWorkers = filteredWorkers.filter(worker => {
                return worker.rating === this.state.ratingFilter
            })
        }

        if (this.state.categoryFilter !== "All") {
            filteredWorkers = filteredWorkers.filter(worker => {
                return worker.categories.indexOf(this.state.categoryFilter) > -1
            })
        }

        if (this.state.searchString) {
            filteredWorkers = filteredWorkers.filter(worker => {
                return (
                    (worker.name.toLowerCase()).indexOf(this.state.searchString.toLowerCase()) > -1
                    || (worker.email.toLowerCase()).indexOf(this.state.searchString.toLowerCase()) > -1
                )
            })
        }

        // Apply column sorting
        switch (this.state.sortColumn) {
            case "registered":
                filteredWorkers.sort((a, b) => a.created_at < b.created_at ? -1 : 1)
                break;
            case "lastActive":
                filteredWorkers.sort((a, b) => a.last_active_at < b.last_active_at ? -1 : 1)
                break;
            case "rating":
                filteredWorkers.sort((a, b) => a.rating < b.rating ? -1 : 1)
                break;
            case "worker":
            default:
                filteredWorkers.sort((a, b) => a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1)
                break;
        }

        if (this.state.sortOrder === "desc") {
            filteredWorkers.reverse()
        }

        return filteredWorkers
    }

    getCompletionRate() {
        if (this.props.workers) {
            return `${this.props.workersCompletionRate}% (${this.props.workersCompleted}/${this.props.workersTotal})`
        } else {
            return 0
        }
    }

    getInProgressRate() {
        if (this.props.workers) {
            return `${this.props.workersInProgressRate}% (${this.props.workersInProgress}/${this.props.workersTotal})`
        } else {
            return 0
        }
    }

    getNotStartedRate() {
        if (this.props.workers) {
            return `${this.props.workersNotStartedRate}% (${this.props.workersNotStarted}/${this.props.workersTotal})`
        } else {
            return 0
        }
    }

    prepareDeleteWorkerModal() {
        return (
            <Modal show={this.state.showDeleteWorkerModal} onHide={this.closeDeleteWorkerModal}  >
                <Modal.Header>
                    <Modal.Title componentClass="h2">Confirm Disconnection</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <h4><b>Are you sure</b> you want to disconnect <b>{this.state.workerToDeleteName}</b> from your organisation?</h4>
                    <br />
                    <h4>They will <b>lose access</b> to all modules and performance results and you will no longer be able to see their results.</h4>
                    <br />
                    <h4><b>Note:</b> There is no limit on the number of workers you can keep and you will not be further charged for keeping the worker connected to your account.</h4>
                </Modal.Body>
                <Modal.Footer>
                    <Row>
                        <Col sm={6}>
                            <Button bsStyle="primary" onClick={this.confirmDeleteWorker}>Confirm</Button>
                        </Col>
                        <Col sm={6}>
                            <Button bsStyle="primary" onClick={this.closeDeleteWorkerModal}>Cancel</Button>
                        </Col>
                    </Row>
                </Modal.Footer>
            </Modal>
        )
    }

    evalWorkerStatus(worker) {
        return "Registered"
    }

    evalModulesCompleted(workerModules) {
        let completed = 0

        workerModules.forEach(module => {
            if (module.completed) {
                completed++
            }
        })

        return workerModules.length === 0 ? '' : completed + "/" + workerModules.length
    }

    printReport() {
        this.setState({
            currentDate: evalDateHour(Date.now())
        })
        setTimeout(() => { window.print() }, 1500)
    }

    downloadCSV() {
        let filteredWorkers = this.getFilteredWorkers()

        let csv = 'Name,Email,Registered,Last Active,Rating,Category1,Category2,Category3\n';
        filteredWorkers.forEach(function (row) {
            csv += row.name + "," + row.email + "," + row.createdAtDate + "," + row.lastActiveDate + "," + row.rating + "," + row.categories + "\n"
        })

        let hiddenElement = document.createElement('a')
        hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv)
        hiddenElement.target = '_blank'
        hiddenElement.download = "Enabler Workforce Report - " + this.props.appData.company + " - " + evalDateHour(Date.now()) + ".csv"
        hiddenElement.click()
    }

    render() {
        let breadcrumb = (<div className="breadcrumb"><span><Link to="/workforce">Workforce</Link></span>/</div>)

        return (
            <div className="summary-container">
                <Row>
                    <Col sm={10} md={10} xs={10} smOffset={1} mdOffset={1} xsOffset={1}>
                        <div className="main-header">
                            {breadcrumb}
                            <h2 className="title">Manage Workforce</h2>
                        </div>
                    </Col>
                </Row>
                <Row className="print-panel">
                    <Col sm={4} md={4} xs={10} smOffset={1} mdOffset={1} xsOffset={1}>
                        <Panel>
                            <Panel.Heading>
                                Summary
                            </Panel.Heading>
                            {(this.props.workersTotal > 0) && <Panel.Body>
                                <p>Total workers: {this.props.workersTotal}</p>
                                <p>Workers who have completed all training: {this.getCompletionRate()}</p>
                                <p>Workers who are in progress: {this.getInProgressRate()}</p>
                                <p>Workers who haven't started training: {this.getNotStartedRate()}</p>
                            </Panel.Body>}
                        </Panel>
                    </Col>
                    <Col sm={6} md={6} xs={10} smOffset={1} mdOffset={1} xsOffset={1}>
                        <Row>
                            <Col sm={6} md={6}>
                                <Button bsStyle="primary" onClick={this.printReport}>Print</Button>
                            </Col>
                            <Col sm={6} md={6}>
                                <Button bsStyle="primary" onClick={this.downloadCSV}>Export to CSV</Button>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Row>
                    <Col xsOffset={1} xs={10} smOffset={1} sm={10} mdOffset={1} md={10}>
                        <Table responsive bsClass="table">
                            <thead>
                                <tr>
                                    <th id="worker" onClick={this.sortColumn} className="sort-column">Worker {this.sortIcon("worker")}</th>
                                    <th id="registered" onClick={this.sortColumn} className="sort-column">Registered {this.sortIcon("registered")}</th>
                                    <th id="lastActive" onClick={this.sortColumn} className="sort-column">Last Active {this.sortIcon("lastActive")}</th>
                                    <th id="rating" onClick={this.sortColumn} className="sort-column">Rating {this.sortIcon("rating")}</th>
                                    <th>Categories</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr className="filter-panel">
                                    <td>
                                        <form id="search">
                                            <FormGroup controlId="formSearchString">
                                                <FormControl type="text" placeholder="Search Worker" inputRef={ref => { this.searchInput = ref }} onChange={this.searchWorker} />
                                            </FormGroup>
                                        </form>
                                    </td>
                                    <td></td>
                                    <td></td>
                                    <td>
                                        <form id="filterRating" >
                                            <FormGroup controlId="formRatingFilter">
                                                <FormControl componentClass="select" placeholder="select" inputRef={ref => { this.ratingInput = ref }} onChange={this.filterRating}>
                                                    <option value="All">All</option>
                                                    <option value="Excellent">Excellent</option>
                                                    <option value="Good">Good</option>
                                                    <option value="Pass">Pass</option>
                                                    <option value="Poor">Poor</option>
                                                    <option value="In Progress">In Progress</option>
                                                    <option value="Not Started">Not Started</option>
                                                </FormControl>
                                            </FormGroup>
                                        </form>
                                    </td>
                                    <td>
                                        <form id="filterCategory">
                                            <FormGroup controlId="formCategoryFilter">
                                                <FormControl componentClass="select" placeholder="select" inputRef={ref => { this.categoryInput = ref }} onChange={this.filterCategory}>
                                                    <option value="All">All</option>
                                                    {this.loadCategoryFilterOptions()}
                                                </FormControl>
                                            </FormGroup>
                                        </form>
                                    </td>
                                    <td></td>
                                </tr>
                                {this.records}
                            </tbody>
                        </Table>
                    </Col>
                </Row>
                <Row>
                    <Col smOffset={8} sm={3} mdOffset={8} md={3}>
                        <div className="license-info">
                            <Button bsStyle='primary' disabled={this.state.editingCategory} onClick={this.handleOnClick}>Add Workers</Button>
                        </div>
                    </Col>
                </Row>
                <Clearfix />
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/containers/workforceSummary.js